import { Redirect, RedirectProps } from "react-router-dom";
import { ActionFeedback } from "@omnijus/common";
import React from "react";

export const RedirectWithErrorMessage = (props: RedirectProps & { errorMessage: string }) => {
    ActionFeedback.error({ title: props.errorMessage }).then();
    return <Redirect {...props} />;
};
